import { render } from "./InfoBox.vue?vue&type=template&id=1e60e558&scoped=true"
import script from "./InfoBox.vue?vue&type=script&lang=js"
export * from "./InfoBox.vue?vue&type=script&lang=js"

import "./InfoBox.vue?vue&type=style&index=0&id=1e60e558&lang=scss&scoped=true"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e60e558"]])

export default __exports__